import { CompanyList } from 'ui/components/agent/patterns/CompanyList/CompanyList';

/**
 * 仲介企業用　売り手企業一覧
 */
export const AgentCompanyList: React.FC = () => {
    return <CompanyList />;
};
